import data from "../../.sourceflow/history.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getHistory = (locale = "en") => {
  return new BaseCollection(data, locale).getItems();
};
